
import React, { useCallback, useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import axios from "axios";

import DetailsSection from "./components/DetailsSection";
import Loading from "../admin/childComponents/appComponents/Loading";
import "../../assets/css/Read.css";

const BASE_URL = process.env.REACT_APP_API_BASE_URL;

function Read() {
  const { reads } = useParams();

  const [loading, setLoading] = useState(true);
  const [readData, setReadData] = useState({});
  const [error, setError] = useState(false);

  const fetchReadData = useCallback(async () => {
    if (!reads) {
      setReadData({});
      setError(true);
      setLoading(false);
      return;
    }

    setLoading(true);
    setError(false);

    try {
      const response = await axios.get(`${BASE_URL}read-data`, {
        params: { id: reads },
      });

      setReadData(response?.data?.data || {});
    } catch (err) {
      console.error("Unable to load article:", err);
      setReadData({});
      setError(true);
    } finally {
      setLoading(false);
    }
  }, [reads]);

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });

    fetchReadData();
  }, [fetchReadData]);

  if (loading) {
    return (
      <div className="read-loading-wrapper">
        <Loading message01="Loading article..." />
      </div>
    );
  }

  const articleList = readData?.readSection?.data || [];

  if (error || articleList.length === 0) {
    return (
      <main className="read-state-section">
        <div className="container">
          <div className="read-state-card">
            <div className="read-state-icon">
              <i
                className={`fa-solid ${
                  error ? "fa-triangle-exclamation" : "fa-file-circle-xmark"
                }`}
                aria-hidden="true"
              />
            </div>

            <span className="read-state-eyebrow">
              {error ? "CONNECTION ISSUE" : "CONTENT UNAVAILABLE"}
            </span>

            <h1>
              {error ? "Unable to Load This Page" : "Article Not Found"}
            </h1>

            <p>
              {error
                ? "We could not retrieve this content at the moment. Please check your connection and try again."
                : "The requested article may have been moved, removed, or is no longer available."}
            </p>

            {error && (
              <button
                type="button"
                className="read-retry-button"
                onClick={fetchReadData}
              >
                <i className="fa-solid fa-rotate-right" aria-hidden="true" />
                Try Again
              </button>
            )}

            <Link to="/" className="read-home-button">
              <i className="fa-solid fa-house" aria-hidden="true" />
              Return to Homepage
            </Link>
          </div>
        </div>
      </main>
    );
  }

  return (
    <main className="read-page">
      <div className="read-top-accent" />

      <div className="read-content-wrapper">
        <DetailsSection
          datacontent={articleList}
          downloadSection={readData?.downloadSection?.data || []}
          sideNewSection={readData?.sideNewSection?.data || []}
          advertSection={readData?.advertSection?.data || []}
          initialPagination={readData?.readSection?.pagination || {}}
          initialPaginationDownload={
            readData?.downloadSection?.pagination || {}
          }
          datacontentDataSearch={
            readData?.readSection?.dataSearch || {}
          }
        />
      </div>
    </main>
  );
}

export default React.memo(Read);
